import { Controller, useFormContext } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';
import es from 'react-phone-input-2/lang/es.json';
import useTranslation from 'next-translate/useTranslation';

import en from './desplegable.json';

import type { FunctionComponent } from 'react';
import type { TypePhoneInputProps } from './types';
import 'react-phone-input-2/lib/style.css';
import type { TypePhoneCountry } from '@/types';

/**
 * PhoneInput
 */
export const PhoneInputBase: FunctionComponent<TypePhoneInputProps> = ({
  name,
  requiredMessage,
  label,
  setPhoneCountry,
}: TypePhoneInputProps) => {
  const { t, lang } = useTranslation('common');
  const {
    formState: { errors },
    control,
    trigger,
  } = useFormContext();

  const styleButton = {
    backgroundColor: 'transparent',
    border: 0,
    paddingBottom: '0.5rem',
  };

  const inputStyle = {
    paddingBottom: '0.5rem',
    height: '23px',
    width: '100%',
    borderWidth: '1px',
    backgroundColor: 'rgb(0 0 0 / 0%)',
    borderStyle: 'hidden',
    borderRadius: '0px',
    letterSpacing: '0.012em',
    color: errors[name] ? '#ff0000' : 'var(--tw-color-primary-400)',
    borderBottom: `1px solid ${
      errors[name] ? '#ff0000' : 'var(--tw-color-primary-400)'
    }`,
    outline: '0rem solid',
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: '16px',
    lineHeight: '22px',
    '&::placeholder': {
      color: errors[name] ? '#ff0000' : 'var(--tw-color-primary-400)',
    },
  };

  const handler = async (
    value: string,
    country: TypePhoneCountry,
    onChange: (value: string) => void
  ) => {
    await trigger(name);
    setPhoneCountry(country);
    onChange(value);
  };

  return (
    <div className="flex h-full flex-col gap-2">
      <style>
        {`
          .selected-flag {
            background-color: transparent !important;
          }

          .country-list {
            .country{
              background-color: #fdf7ed;
              color: #9b7b6f;
            }
          }
        `}
      </style>
      <label className="text-other--label-form mb-auto uppercase">
        {label} {requiredMessage && ' *'}
      </label>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <PhoneInput
            value={value}
            localization={lang === 'es' ? es : en}
            inputStyle={inputStyle}
            buttonStyle={styleButton}
            country={t('components.atoms.inputPhone.code').toString()}
            inputProps={{
              name: 'phone',
              required: true,
            }}
            onMount={(value, country: TypePhoneCountry) =>
              setPhoneCountry(country)
            }
            onChange={(value, country: TypePhoneCountry) =>
              handler(value, country, onChange)
            }
          />
        )}
      />
      <span
        className={`text-other--detail text-[#ff0000] ${
          Object.keys(errors).indexOf(name) < 0 ? 'hidden' : 'block'
        }`}
      >
        {errors[name]?.message || requiredMessage}
      </span>
    </div>
  );
};

PhoneInputBase.displayName = 'PhoneInput';
